module.exports = __webpack_public_path__ + "static/change-logo-position-34ce97b777240e04445efe8f7bb12198.png";